import React, { useContext } from 'react'
import { AgTechTabPageContext } from '../../Pages/Tabbed/AgTechTabPage'
import { AgTechTourConfig } from './AgTechTourTypes'
import AgTechTourHelpButton from './AgTechTourHelpButton'

type AgTechTabTourButtonProps = {
    tourConfigs: Record<string, AgTechTourConfig>
    classes?: string
}

const AgTechTabTourButton = ({ tourConfigs, classes }: AgTechTabTourButtonProps) => {
    const { currentTab } = useContext(AgTechTabPageContext)
    const activeTourConfig = currentTab?.id ? tourConfigs[currentTab.id] : undefined

    if (!activeTourConfig) return null

    return <AgTechTourHelpButton tourConfig={activeTourConfig} classes={classes} />
}

export default AgTechTabTourButton
